import * as http from '../axios/index';
const REQUEST_DATA = 'REQUEST_DATA';
const RECEIVE_DATA = 'RECEIVE_DATA';

export const handleData = (state = {isFetching: true, data: {}}, action) => {
    switch (action.type) {
        case REQUEST_DATA:
            return {...state, isFetching: true};
        case RECEIVE_DATA:
            return {...state, isFetching: false, data: action.data};
        default:
            return {...state};
    }
};
export const httpData = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_DATA:
        case REQUEST_DATA:
            return {
                ...state,
                [action.category]: handleData(state[action.category], action)
            };
        default:
            return {...state};
    }
};




export const requestData = category => ({
    type: REQUEST_DATA,
    category
});
export const receiveData = (data, category) => ({
    type: RECEIVE_DATA,
    data,
    category
});
/**
 * 请求数据调用方法
 * @param funcName      请求接口的函数名
 * @param params        请求接口的参数
 */
export const fetchData = ({funcName, params, stateName}) => dispatch => {
    !stateName && (stateName = funcName);
    dispatch(requestData(stateName));
    return http[funcName](params).then(res => dispatch(receiveData(res, stateName)));
};

export const fetchCall = ({ stateName,stateVal}) => dispatch => {
    dispatch(requestData(stateName));
    dispatch(receiveData(stateVal, stateName));
    return false
};


// WEBPACK FOOTER //
// ./src/reducer/httpData.redux.js